// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statics[data-v-df6b40e6] {\n  width: auto;\n  background: #e6f7ff;\n  height: 38px;\n  line-height: 38px;\n  vertical-align: middle;\n}\n.span-blue[data-v-df6b40e6] {\n  color: #3ba1e5;\n  margin-left: 20px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
